import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import {
    SubscriptionPlanModelInterface,
    SubscriptionPlanModelResponse,
} from 'src/app/interface/subscription-plan-model.interface';
import { OpenIdProfilePaginatorBase } from 'src/app/mixin/presets';
import { OpenIdService } from 'src/app/service/open-id.service';
import { ConfirmComponent } from 'src/app/dialog/confirm/confirm.component';

@Component({
    selector: 'app-view-subscriptions-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.css'],
})
export class PlansComponent
    extends OpenIdProfilePaginatorBase
    implements AfterViewInit, OnInit
{
    public columnHeadings: string[] = [
        'control',
        'id',
        'tiers',
        //'owner',
        'enabled',
        'label',
        'subscriber_count',
        'description',
        'webhook',
    ];

    private offset: number = 0;
    public planModels: SubscriptionPlanModelInterface[] = [];
    public token?: string;

    @ViewChild(MatPaginator) public paginator?: MatPaginator;
    constructor(
        private dialog: MatDialog,
        private httpClient: HttpClient,
        openIdService: OpenIdService
    ) {
        super(openIdService);
    }

    ngOnInit(): void {
        this.$openIdReady.subscribe(() => {
            this.getRecords();

            this.httpClient.get('users/token/', {}).subscribe((resp: any) => {
                this.token = resp.token;
            });
        });
    }

    ngAfterViewInit(): void {
        this.handlePaging(this.paginator!, (offset) => this.getRecords(offset));
    }

    public confirmDelete(planModel: SubscriptionPlanModelInterface) {
        let dialog = this.dialog.open(ConfirmComponent, {
            data: {
                label: 'Plan Delete Request',
                message: `Delete plan ${planModel.label}?`,
            },
        });

        dialog.afterClosed().subscribe((data) => {
            if (!data.data) return;
            this.httpClient
                .delete(`subscription_plans/${planModel.id}/`)
                .subscribe(() => {
                    this.getRecords();
                });
        });
    }

    public getRecords(offset: number = 0) {
        this.offset = offset;
        let options = {
            params: new HttpParams()
                .set('limit', this.pagingPageSize)
                .set('offset', offset)
                .set('receiver_open_id', this.openIdProfile!.id)
                .set('ordering', 'label'),
        };

        this.httpClient
            .get<SubscriptionPlanModelResponse>('subscription_plans/', options)
            .subscribe((response: SubscriptionPlanModelResponse) => {
                this.pagingItemCount = response.count;
                this.planModels = response.results;
            });
    }

    public toggleEnabled(cPlanModel: SubscriptionPlanModelInterface) {
        let payload = {
            enabled: !cPlanModel.enabled,
        };

        this.httpClient
            .patch(`subscription_plans/${cPlanModel.id}/`, payload)
            .subscribe((resp) => {
                this.getRecords();
            });
    }
}
